<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.ENFERMAGEM">
            <rkm-layout-body title="Atendimento de enfermagem">
                <template v-slot:actions>
                    <rkm-button
                        v-if="data"
                        @click="$refs.ModalAgendamentoRetroativo.open()"
                        color="primary"
                    >
                        Registro retroativo
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List @data-load="data = $event" />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Atendimento de enfermagem">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>ENFERMAGEM</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>

        <ModalAgendamentoRetroativo
            v-if="data"
            :data-atual="data.additionals.dataAtual"
            origem="enfermagem"
            ref="ModalAgendamentoRetroativo"
        />
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/atendimento-enfermagem/List'
import ModalAgendamentoRetroativo from '@/components/ambulatorio/components/agendamento-retroativo/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {List, ModalAgendamentoRetroativo},
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
    },
    data: () => ({
        data: null,
        enums: {setorTipo},
    }),
}
</script>